import { useContext } from "react";
import { Context } from "../../context/context";
import { Link } from "react-router-dom";
import {
  FaUserPlus,
  FaFileUpload,
  FaSignOutAlt,
  FaMapMarked,
} from "react-icons/fa";
import { IoMdPricetag } from "react-icons/io";
import { HiReceiptTax } from "react-icons/hi";

import "./Registration.scss";
export default function Registration() {
  const { sidebar } = useContext(Context);

  return (
    <>
      <main className={sidebar ? "container" : "container-full"}>
        <h1>Cadastro</h1>
        <div className="cards-container">
          <Link to="/cadastro/usuarios">
            <div>
              <FaUserPlus />
            </div>
            <p className="text">Usuários</p>
          </Link>
          <Link to="/cadastro/preco-custo">
            <div>
              <IoMdPricetag />
            </div>
            <p className="text">Preços e Custos</p>
          </Link>
          <Link to="/cadastro/icms">
            <div>
              <HiReceiptTax />
            </div>
            <p className="text">ICMS</p>
          </Link>
          <Link to="/cadastro/excel">
            <div>
              <FaFileUpload />
            </div>
            <p className="text">Upload Excel</p>
          </Link>
          <Link to="/cadastro/concorrentes">
            <div>
              <FaSignOutAlt />
            </div>
            <p className="text">Concorrentes</p>
          </Link>
          <Link to="/cadastro/zonas-venda">
            <div>
              <FaMapMarked />
            </div>
            <p className="text">Zona de Venda</p>
          </Link>
        </div>
      </main>
    </>
  );
}
